export default __webpack_public_path__ + "static/media/like.e75ac196.png";